import React, { useState } from "react";
import "./Payment_Summary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Confirm_Addess_Modal from "../../common_components/common_modal/confirm_addess_modal/Confirm_Addess_Modal";
import { faBuilding, faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Offcanvas } from "react-bootstrap";
// import Coupon_Card from "../../common_components/coupon_card/Coupon_Card";
import { useNavigate } from "react-router-dom";

import Blue_Round_Btn from "../common-btn/blue_round_btn/Blue_Round_Btn";
import Gray_Outline_Button from "../common-btn/gray_outline_btn/Gray_Outline_Button";

const Payment_Summary = ({
  order,
  viewAllSummary,
  isCheckoutPage,
  checkout_btn,
  checkoutAction,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);

  const navigate = useNavigate();
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);

  return (
    <>
      <div className="payment_summary_div">
        {!viewAllSummary && (
          <h3 className="heading">
            <img src="/assets/images/cart/icon.png" className="icon_img" />{" "}
            Payment Summary <span className="inner_text">(incl GST)</span>
          </h3>
        )}

        <div className="summary">
          <div className="row-divider">
            <div className="title_div">
              <p>Total no. of items</p>
            </div>

            <div className="qty_div">
              <p>{order?.no_of_item} Nos.</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Payment Method</p>
            </div>

            <div className="qty_div">
              <p>{order?.Payment_Method?.name}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Product MRP</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.total_mrp).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Product Discounted Price</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.total_selling_price).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Product Discount</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.total_discount).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Lens MRP</p>
            </div>

            <div className="qty_div">
              <p>₹ -{Number(order?.lens_mrp).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Lens Subtotal</p>
            </div>

            <div className="qty_div">
              <p>₹ -{Number(order?.total_lense_price).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Lens Discount</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.lens_discount).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Reward Points</p>
            </div>

            <div className="qty_div">
              <p>₹ -{Number(order?.reward_discount).toFixed(2) || 0}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Addon total</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.total_addon_price).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Coupon Discount</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.total_coupon_discount).toFixed(2)}</p>
            </div>
          </div>
           <div className="row-divider">
            <div className="title_div">
              <p>Shipping</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.delivery_charges).toFixed(2)}</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Product Tax</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.total_tax).toFixed(2)}</p>
            </div>
          </div>
           <div className="row-divider">
            <div className="title_div">
              <p>Lens Tax</p>
            </div>

            <div className="qty_div">
              <p>₹ {Number(order?.lens_tax).toFixed(2)}</p>
            </div>
          </div>


          <div className="total_div">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_title_div">
                  <p>Grand Total</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_qty_div">
                  <p>{Number(order?.total_amount).toFixed(2)}</p>
                </div>
              </div>
            </div>
          </div>

          {/* {!isCheckoutPage && (
                        <>
                            <div className="forgot_div">
                                <p className="forgot_text">Forgot Something?</p>
                                <div className="add_btn_div">
                                    <Blue_Round_Btn btnText="+ Add more items" onClick={() => {navigate("/all-products")}}/>
                                </div>
                            </div>

                            <div className="checkout_btn">
                                <Blue_Round_Btn btnText="Proceed To Checkout" onClick={() => { setShowModal(true) }} />
                            </div>
                        </>
                    )} */}
        </div>

      
      </div>

      {isCheckoutPage && (
        <div className="payment_summary_div coupon_main_div">
          <div className="coupon_div">
            <div className="special_div">
              <img
                src="/assets/images/checkout/green_discount.png"
                className="discount_img"
              />
              <p className="special_text">Something Special for you!</p>
            </div>
            <div className="coupons_div">
              <div className="left_side">
                <FontAwesomeIcon icon={faTags} className="tag_icon" />
                <span className="coupon_text">Coupons</span>
              </div>
              <div className="btn_holder">
                <button
                  className="black_btn"
                  onClick={() => {
                    setShowOffCanvas(true);
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>

          <div className="checkout_btn">
            <Blue_Round_Btn btnText={checkout_btn} onClick={checkoutAction} />
          </div>
        </div>
      )}
      {/* 
            <Confirm_Addess_Modal
                show={showModal}
                onHide={() => { setShowModal(false) }}
            /> */}

      <Offcanvas
        className="right_bottom_offcanvas"
        placement="bottom"
        show={showOffCanvas}
        onHide={() => {
          setShowOffCanvas(false);
        }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faTags} className="tag_icon" /> Coupons
          </Offcanvas.Title>
          <div
            className="icon_holder"
            onClick={() => {
              setShowOffCanvas(false);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="close_icon" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="coupon_cards_div">
            {/* <Coupon_Card showtc />
                        <Coupon_Card /> */}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        className="right_bottom_offcanvas confirm_delivery_address_offcanvas"
        placement="bottom"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Offcanvas.Body>
          <div className="Confirm_Addess_Modal">
            <div className="modal-content">
              <div className="modal-header">
                <div className="title_text">
                  <p>Confirm Delivery Address</p>
                </div>

                <div className="right_side">
                  <img
                    src="/assets/images/cart/close.png"
                    className="close_img"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  />
                </div>
              </div>

              <div className="modal-body">
                <div className="address_holder">
                  <p className="type_text">
                    {" "}
                    <FontAwesomeIcon
                      icon={faBuilding}
                      className="inner_icon"
                    />{" "}
                    Apartment
                  </p>

                  <p className="address_text">
                    Shivkrupa Colony, Alkapuri Society, Kothrud, Pune,
                    Maharashtra, 411038
                  </p>

                  <div className="btns_holder">
                    <Gray_Outline_Button
                      btnText="Update Address"
                      onClick={() => {
                        navigate("/saved-address");
                      }}
                    />
                    <Blue_Round_Btn
                      btnText="Proceed"
                      onClick={() => {
                        navigate("/checkout");
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Payment_Summary;
